import React from 'react';
import '../template-file-css/document-file-template.css';


export const RPBS_ConsentForFollow = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='RPBS_ConsentForFollow' className='file-pdf-document'>
            <div className='file-template'>
            <p className='w-750'>   <h3>INFORMED CONSENT FOR FOLLOW-UP SURVEY</h3></p>
                <p className='w-750'>
                    l,
                    <input type='text' id="txtBehavioral" name="txtBehavioral" className='add-only w-375 custom-add-only' />
                    a client of Right Path Behavioral Health Services
                </p>
                <p className='w-750'>or</p>
                <p className='w-750'>
                    I,
                    <input type='text' id="txtBehavioral1" name="txtBehavioral1" className='add-only w-250 custom-add-only' />, the parent/guardian of
                    <input type='text' id="txtBehavioral2" name="txtBehavioral2" className='add-only w-250 custom-add-only' />
                    , a client of Right Path Behavioral Health Services

                    give permission for Right Path Behavioral Health Services staff to contact me regarding my or
                    child's/ward's treatment and services inGluding current or post treatment behavior.
                </p>
                <p className='w-750'><strong>My contact information is (please print):</strong></p>
                <table>
                    <tr>
                        <td className='w-250'><span className='eleHeader'>(Street)</span><input type='text' id="txtStreet" name="txtStreet" className='add-only' /></td>
                        <td className='w-250'><span className='eleHeader'>(City, State, Zip)</span><input type='text' id="txtState" name="txtState" className='add-only' /></td>
                        <td className='w-250'><span className='eleHeader'>(Phone Number)</span><input type='text' id="txtPhoneNumber" name="txtPhoneNumber" className='add-only' /></td>
                    </tr>
                </table>

                <p className='w-750'>
                    If Right Path Behavioral Health Services is unable to reach me at the above address or phone number I give permission for Right Path Behavioral Health Services to contact the following individuals
                    concerning any forwarding phone numbers or addresses where I may be reached. If Right Path Behavioral Health Services personnel cannot reach me, I give permission for the person(s) named below to answer questions about my or my child's/ward's current progress or me or my child's/ward's progress since leaving treatment by answering the questions in the follow-up survey to the best of their knowledge.
                </p>
                <table>
                    <tr>
                        <td className='w-187'>&nbsp;</td>
                        <td className='w-187'><center><b>1.</b></center></td>
                        <td className='w-187'><center><b>2.</b></center></td>
                        <td className='w-187'><center><b>3.</b></center></td>
                    </tr>
                    <tr>
                        <td className='w-187'><strong>Print Name</strong></td>
                        <td className='w-187'> <input type='text' id="txtPrint" name="txtPrint" className='add-only' /></td>
                        <td className='w-187'> <input type='text' id="txtPrint1" name="txtPrint1" className='add-only' /></td>
                        <td className='w-187'> <input type='text' id="txtPrint2" name="txtPrint2" className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-187'><strong>Relationship</strong></td>
                        <td className='w-187'>
                            <input type='text' id="txtPrintRelationship" name="txtPrintRelationship" className='add-only' /></td>
                        <td className='w-187'>
                            <input type='text' id="txtPrintRelationship1" name="txtPrintRelationship1" className='add-only' /></td>
                        <td className='w-187'>
                            <input type='text' id="txtPrintRelationship2" name="txtPrintRelationship2" className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-187'><strong>Street</strong></td>
                        <td className='w-187'>
                            <input type='text' id="txtPrintStreet" name="txtPrintStreet" className='add-only' /></td>
                        <td className='w-187'>
                            <input type='text' id="txtPrintStreet1" name="txtPrintStreet1" className='add-only' /></td>
                        <td className='w-187'>
                            <input type='text' id="txtPrintStreet2" name="txtPrintStreet2" className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-187'><strong>City, State/Zip</strong></td>
                        <td className='w-187'>
                            <input type='text' id="txtPrintCity" name="txtPrintCity" className='add-only' /></td>
                        <td className='w-187'>
                            <input type='text' id="txtPrintCity1" name="txtPrintCity1" className='add-only' /></td>
                        <td className='w-187'>
                            <input type='text' id="txtPrintCity2" name="txtPrintCity2" className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-187'><strong>Phone #</strong></td>
                        <td className='w-187'>
                            <input type='text' id="txtPhone" name="txtPhone" className='add-only' /></td>
                        <td className='w-187'>
                            <input type='text' id="txtPhone1" name="txtPhone1" className='add-only' /></td>
                        <td className='w-187'>
                            <input type='text' id="txtPhone2" name="txtPhone2" className='add-only' /></td>
                    </tr>
                </table>


                
            </div>
        </form>

    )
}











